import { useEffect, useState } from "react";
import { Card, Row, Col, DatePicker, Form, Button, Slider } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import UserDesignationMultipleSelector from "../../../components/selector/user.designation.multiple.selector";
import { data } from "react-router-dom";
import dayjs from "../../../utils/daysjs.config";
const { RangePicker } = DatePicker;

const FilterToolbar = ({ filters, onFilterChange }) => {
  const [selectedDesignations, setSelectedDesignations] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);

  const { designationRankingLimit, conditionRankingLimit } = filters;

  const rangePresets = [
    { label: "Last 7 Days", value: [dayjs().subtract(7, "days"), dayjs()] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "days"), dayjs()] },
    { label: "Last 3 months", value: [dayjs().subtract(3, "months"), dayjs()] },
    { label: "Last 6 months", value: [dayjs().subtract(6, "months"), dayjs()] },
    { label: "Last 1 year", value: [dayjs().subtract(1, "year"), dayjs()] },
    { label: "All Time", value: [dayjs(new Date("2025-06-01")), dayjs()] },
  ];

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setIsFilterActive(dateRange[0] || dateRange[1]);
  }, [dateRange]);

  const onDateChange = (dates) => {
    setDateRange(dates ?? []);
  };

  return (
    <Card
      style={{
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        marginTop: "24px",
        marginBottom: "12px",
      }}
      styles={{
        body: { padding: "4px 6px", marginBottom: "24px" },
        marginBottom: "24px",
      }}
    >
      <Form layout="vertical" style={{ width: "100%" }}>
        <Row
          gutter={24}
          style={{ width: "100%", alignItems: "flex-start", marginBottom: 12 }}
        >
          {/* <Col xs={24} sm={12} md={10} lg={10} style={{ minWidth: 220 }}>
            <Form.Item
              label="Designation(s)"
              style={{ marginBottom: 0, marginTop: 8, width: "100%" }}
              labelCol={{ style: { marginBottom: 4 } }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 0,
                }}
              >
                <UserDesignationMultipleSelector
                  value={selectedDesignations}
                  onChange={setSelectedDesignations}
                  style={{ width: "100%" }}
                />
              </div>
            </Form.Item>
          </Col> */}
          <Col xs={24} sm={12} md={10} lg={10} style={{ minWidth: 220 }}>
            <Form.Item
              label="Period"
              style={{ marginBottom: 0, marginTop: 10, width: "100%" }}
              labelCol={{ style: { marginBottom: 4 } }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 6,
                }}
              >
                <RangePicker
                  style={{
                    width: "100%",
                    borderRadius: "6px",
                    minWidth: "20vw",
                  }}
                  presets={rangePresets}
                  onChange={onDateChange}
                  value={dateRange}
                  suffixIcon={
                    <CalendarOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                />
              </div>
            </Form.Item>
          </Col>
          <Col xs={24} sm={6} md={7} lg={7}>
            <Form.Item
              label="Conditions Ranking"
              style={{ marginBottom: 0, marginTop: 10, width: "100%" }}
              labelCol={{ style: { marginBottom: 4 } }}
            >
              <Slider
                marks={{ 3: "3", 5: "5", 10: "10" }}
                step={null}
                value={conditionRankingLimit}
                max={10}
                min={3}
                onChange={(value) => {
                  onFilterChange((prev) => {
                    return { ...prev, conditionRankingLimit: value };
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={6} md={7} lg={7}>
            <Form.Item
              label="Designations Ranking"
              style={{ marginBottom: 0, marginTop: 10, width: "100%" }}
              labelCol={{ style: { marginBottom: 4 } }}
            >
              <Slider
                marks={{ 3: "3", 5: "5", 10: "10" }}
                step={null}
                value={designationRankingLimit}
                max={10}
                min={3}
                onChange={(value) => {
                  onFilterChange((prev) => {
                    return { ...prev, designationRankingLimit: value };
                  });
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} style={{ width: "100%", alignItems: "flex-start" }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ minWidth: 220 }}>
            <Button
              disabled={!isFilterActive}
              primary
              style={{ width: "100%", minWidth: "200px" }}
              onClick={() => {
                onFilterChange((prev) => {
                  return {
                    ...prev,
                    dateRange,
                  };
                });
              }}
            >
              Apply Filters
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default FilterToolbar;
